import React from "react"
import PropTypes from "prop-types"
// import styled from 'styled-components';

import { Select } from "antd"
import "./index.less"
import { LOCAL_LOGIN_LANGUAGE, KEY_LOGIN_LANGUAGE, setItem } from "../../utils/storage"
import { GlobalOutlined } from "@ant-design/icons"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export const LanguageSelector = (props) => {

    const onChangeLanguage = (value) => {
        setItem(KEY_LOGIN_LANGUAGE, value)
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)
        urlParams.set("language", value)
        window.location.href = window.location.pathname + "?" + urlParams.toString()
    }

    //check subdomain for admin
    const host = window.location.host
    const subdomain = host.split(".")[0]
    if (subdomain.includes("admin")) {
        return null;
    }

    return (
        <Select className="language-selector" value={LOCAL_LOGIN_LANGUAGE()} onChange={onChangeLanguage}>
            <Option value={"es"}>Español</Option>
            <Option value={"en"}>English</Option>
        </Select>
    )
}
